import CustomBadge from '@/components/badge/CustomBadge';
import Container, { CenterContent, Row } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { TextBodyLarge, TextHeadlineMedium } from '@/components/text/Texts';
import { TRAVEL_PROGRAM } from '@/constants/programs';
import type { ReactNode } from 'react';
import styles from '../onboarding.module.css';
import { cn } from '@/components/ui/cn';

type Props = {
	icon: ReactNode;
	title: string;
	titleCls?: string;
};

const AccordionHeader = ({ icon, title, titleCls }: Props) => {
	return (
		<Row>
			<Container className="p-[8px] text-[24px] flex justify-center h-auto w-[48px]">
				{icon}
			</Container>
			<Spacing width="w-[12px]" />
			<Container className="flex self-center">
				<TextBodyLarge text={title} className={cn('text-onSurfaceVariant', titleCls)} />
			</Container>
		</Row>
	);
};

export const ProgramSuggestionCardAccordionHeader = () => {
	return (
		<Row className={styles.rowHeader}>
			<Container className="flex items-center">
				<img
					alt="car and moto icon"
					width="52"
					height="52"
					src="/images/svg/car-and-moto.svg"
				/>
			</Container>
			<Spacing width="w-[16px]" />
			<Row className="flex self-center align-middle">
				<TextHeadlineMedium
					text={TRAVEL_PROGRAM.TITLE}
					className="text-neutral17"
				/>
				<CenterContent className="ml-4">
					<CustomBadge text="Recommended" />
				</CenterContent>
			</Row>
		</Row>
	);
};

export default AccordionHeader;
